import { render, staticRenderFns } from "./AsignarFormato.vue?vue&type=template&id=7b10b5c2&scoped=true"
import script from "./AsignarFormato.vue?vue&type=script&lang=js"
export * from "./AsignarFormato.vue?vue&type=script&lang=js"
import style0 from "./AsignarFormato.vue?vue&type=style&index=0&id=7b10b5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b10b5c2",
  null
  
)

export default component.exports